import React, { useState, useEffect } from 'react';
import api from '../utils/api';
import toast from 'react-hot-toast';

const statusBadge = (s) => {
  const map = { pending:'badge-yellow', approved:'badge-green', rejected:'badge-red' };
  return <span className={`badge ${map[s]||'badge-gray'}`}>{s}</span>;
};

export default function MyWfh() {
  const [requests, setRequests] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm]         = useState({ date:'', reason:'' });
  const [loading, setLoading]   = useState(false);

  useEffect(() => { fetchData(); }, []);

  const fetchData = async () => {
    const res = await api.get('/wfh/my');
    setRequests(res.data);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/wfh/request', form);
      toast.success('WFH request submitted');
      setShowForm(false);
      setForm({ date:'', reason:'' });
      fetchData();
    } catch (err) {
      toast.error(err.response?.data?.error || 'Request failed');
    } finally { setLoading(false); }
  };

  return (
    <div>
      <div className="flex-between mb-16">
        <h1 className="page-title" style={{marginBottom:0}}>WFH Requests</h1>
        <button className="btn btn-primary" onClick={() => setShowForm(!showForm)}>
          {showForm ? 'Cancel' : '+ Request WFH'}
        </button>
      </div>

      {showForm && (
        <div className="card mb-16">
          <div className="card-title">Request Work From Home</div>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">Date</label>
              <input className="form-control" type="date" required
                value={form.date} onChange={e => setForm(f=>({...f,date:e.target.value}))}
                min={new Date().toISOString().split('T')[0]}/>
            </div>
            <div className="form-group">
              <label className="form-label">Reason</label>
              <textarea className="form-control" rows="3"
                value={form.reason} onChange={e => setForm(f=>({...f,reason:e.target.value}))}
                placeholder="Reason for working from home"/>
            </div>
            <button className="btn btn-primary" type="submit" disabled={loading}>
              {loading ? 'Submitting...' : 'Submit Request'}
            </button>
          </form>
        </div>
      )}

      <div className="card">
        <div className="card-title">My WFH History</div>
        <div className="table-wrap">
          <table>
            <thead><tr><th>Date</th><th>Reason</th><th>Status</th><th>Approved By</th><th>Applied On</th></tr></thead>
            <tbody>
              {requests.length === 0 && (
                <tr><td colSpan="5" className="text-center text-muted" style={{padding:24}}>No WFH requests found</td></tr>
              )}
              {requests.map(r => (
                <tr key={r.id}>
                  <td>{new Date(r.date).toLocaleDateString('en-IN',{weekday:'short',day:'2-digit',month:'short',year:'numeric'})}</td>
                  <td>{r.reason || '—'}</td>
                  <td>{statusBadge(r.status)}</td>
                  <td>{r.approved_by_name || '—'}</td>
                  <td>{new Date(r.applied_at).toLocaleDateString('en-IN')}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
